module.exports = __webpack_public_path__ + "img/seanet.070a8eaa.png";